<template>
  <div>
    <div
      v-if="isMobile"
      class="absolute pin-t w-full"
      :class="$style['background-image']"
      :style="{ backgroundImage: 'url('+ require('@/assets/images/cover_mobile3.png') +')' }"
    />

    <div
      v-else
      class="absolute pin-t w-full"
      :class="$style['background-image']"
      :style="{ backgroundImage: 'url('+ require('@/assets/images/cover3.jpeg') +')' }"
    />

    <div
      class="mx-auto"
      :class="$style['box']"
    >
      <div class="relative z-10 ml-10">
        <Logo
          color="white"
        />

        <h1
          class="pr-10 sm:pr-0"
          :class="$style['title']"
        >
          Audi e-tron winter test drive
        </h1>

        <div class="p-5 pl-0">
          <p v-if="!isMobile">
            <span class="font-audi-type-normal text-white text-3xl leading-tight">Descubre el apasionante mundo de la movilidad sin<br>emisiones del Audi e-tron en un entorno inigualable.</span>
          </p>

          <p v-else>
            <span class="font-audi-type-normal text-white text-xl">Descubre el apasionante mundo de la movilidad sin emisiones del Audi e-tron en un entorno inigualable.</span>
          </p>
        </div>

        <div class="mt-5">
          <button
            class="bg-white p-12 pt-5 pb-5 font-audi-type-normal text-base text-dark-grey-audi hover:bg-light-grey-audi"
            @click="scrollToId('reservar')"
          >
            Reservar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Logo from '@c/Logo'

export default {
  components: {
    Logo
  },

  data () {
    return {
      breakpoint: 0
    }
  },

  watch: {
    breakpoint: {
      immediate: true,
      handler: function (newBreakpoint, oldBreakpoint) {}
    }
  },

  computed: {
    isSuccessPage () {
      return this.$route.name === 'success'
    },

    isMobile () {
      return this.breakpoint < 768
    }
  },

  created () {
    this.refreshBreakpoint()
    window.addEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  beforeDestroy () {
    window.removeEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  methods: {
    refreshBreakpoint () {
      this.breakpoint = parseInt(window
        .getComputedStyle(document.querySelector('body'), ':before')
        .getPropertyValue('content')
        .replace(/"/g, ''))
    },

    scrollToId (id) {
      document.getElementById(id).scrollIntoView({ behaviour: 'smooth' })
    }
  }
}
</script>

<style lang="scss" module>
.box {
  max-width: 1600px;
  padding: 100px 0;
}

.background-image {
  height: 800px;
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}

.title {
  font-size: 36px;
  line-height: 46px;
  color: white;
  text-align: left;
  @apply font-audi-type-extendedbold;

  & > p {
    @apply mt-5;
    font-size: 20px;
    line-height: 28px;
  }
}

@media (min-width: 576px) {
  .title {
    font-size: 36px;
    line-height: 32px;
    color: white;
    @apply mt-5;

    & > p {
      font-size: 26px;
      line-height: 32px;
    }
  }

  .box {
    padding: 85px 0;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 46px;
    line-height: 56px;
    margin-bottom: 10px;
  }
}
</style>
